﻿var galleryIntID;
var galleryTimeout = 8000;

function slideShow() {

    //Set the opacity of all images to 0
    $('#gallery a').css({ opacity: 0.0 });

    //Get the first image and display it (set it to full opacity)
    $('#gallery a:first').css({ opacity: 1.0 });

    //Set the caption background to semi-transparent
    $('#gallery .caption').css({ opacity: 0.85 });

    //Set the caption background to semi-transparent
    $('#gallerypaging').css({ opacity: 0.85 });
    
    //Resize the width of the caption according to the image width
    //$('#gallery .caption').css({ width: $('#gallery a').find('img').css('width') });

    //Get the caption of the first image from REL attribute and display it
    $('#gallery .content').html($('#gallery a:first').find('img').attr('rel'));
    $('#gallery .caption').fadeIn(1000);

    //Call the gallery function to run the slideshow, 6000 = change to next image after 6 seconds
    galleryIntID = setInterval('gallery()', galleryTimeout);

}

function gallery() {

    //if no IMGs have the show class, grab the first image
    var current = ($('#gallery a.show') ? $('#gallery a.show') : $('#gallery a:first'));

    //Get next image, if it reached the end of the slideshow, rotate it back to the first image
    var next = ((current.next().length) ? ((current.next().hasClass('caption')) ? $('#gallery a:first') : current.next()) : $('#gallery a:first'));

    gallerySlide(current, next);

}

function galleryNextPage() {
    clearInterval(galleryIntID);
    var current = ($('#gallery a.show') ? $('#gallery a.show') : $('#gallery a:first'));
    var next = ((current.next().length) ? ((current.next().hasClass('caption')) ? $('#gallery a:first') : current.next()) : $('#gallery a:first'));
    gallerySlide(current, next);
    galleryIntID = setInterval('gallery()', galleryTimeout);
}

function galleryPreviousPage() {
    clearInterval(galleryIntID);
    var current = ($('#gallery a.show') ? $('#gallery a.show') : $('#gallery a:first'));
    var next = ((current.prev().length) ? ((current.prev().hasClass('caption')) ? $('#gallery a:last') : current.prev()) : $('#gallery a:last'));
    gallerySlide(current, next);
    galleryIntID = setInterval('gallery()', galleryTimeout);
}


function gallerySlide(current, next) {
    //Get next image caption
    var caption = next.find('img').attr('rel');

    $('#gallery .caption').hide();
    //Set the fade in effect for the next image, show class has higher z-index
    next.css({ opacity: 0.0 })
    .addClass('show')
    .animate({ opacity: 1.0 }, 1000);

    //Hide the current image
    current.animate({ opacity: 0.0 }, 2000).removeClass('show');

    var curIndex = current.index() + 1;
    var nextIndex = next.index() + 1;
    
    $('#gallerypaginglink' + nextIndex).addClass('current')
    $('#gallerypaginglink' + curIndex).removeClass('current')

    //Display the content
    $('#gallery .content').html(caption);
    $('#gallery .caption').fadeIn(1000);

}

function galleryGoTo(pageNo) {
    clearInterval(galleryIntID);
    var current = ($('#gallery a.show') ? $('#gallery a.show') : $('#gallery a:first'));
    var next = $('#gallery a:nth-child(' + pageNo + ')');
    gallerySlide(current, next);
    galleryIntID = setInterval('gallery()', galleryTimeout);
}